var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-table management-main-list-data-table" },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "management-section-wrapper" },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "management-section-title" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$tc("CustomFields", 2)) + "\n      "
                )
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("v-text-field", {
                staticClass: "data-table-search",
                attrs: {
                  value: _vm.searchFromParent,
                  "append-icon": "search",
                  label: _vm.$t("Search"),
                  "single-line": "",
                  "hide-details": ""
                },
                on: { input: _vm.updateSearchInParent }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-data-table", {
            class: { "no-show-permission": !_vm.userHasPermissionTo("show") },
            attrs: {
              headers: _vm.headers,
              items: _vm.customFields,
              search: _vm.searchFromParent,
              loading: _vm.loading,
              "loading-text": "",
              page: _vm.pagination.page,
              "items-per-page": _vm.paginationCustomFields.rowsPerPage,
              "items-per-page-text": _vm.rowsPerPageText,
              "items-per-page-items": _vm.rowsPerPageItems,
              "header-props": { sortIcon: _vm.sortIcon },
              "footer-props": {
                prevIcon: _vm.prevIcon,
                nextIcon: _vm.nextIcon,
                "items-per-page-options": _vm.rowsPerPageItems
              }
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.pagination, "page", $event)
              },
              "update:itemsPerPage": function($event) {
                return _vm.$set(
                  _vm.paginationCustomFields,
                  "rowsPerPage",
                  $event
                )
              },
              "update:items-per-page": function($event) {
                return _vm.$set(
                  _vm.paginationCustomFields,
                  "rowsPerPage",
                  $event
                )
              },
              pagination: function($event) {
                return _vm.setRowsOnLocalStorage(
                  _vm.dataTableCustomFieldsId,
                  _vm.paginationCustomFields.rowsPerPage
                )
              }
            },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function(props) {
                  return [
                    _c(
                      "tr",
                      {
                        class: {
                          "cursor-pointer": _vm.userHasPermissionTo("show")
                        },
                        on: {
                          click: function($event) {
                            return _vm.readField(props.item)
                          }
                        }
                      },
                      [
                        _c("td", [_vm._v(_vm._s(props.item.code))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.label))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.getObjectData(props.item)))
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.getInputTypeName(props.item.input_type))
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "edit-delete-button" },
                          [
                            _c("app-datatable-action-buttons", {
                              attrs: {
                                "user-can-edit": _vm.canEditField,
                                "user-can-delete": _vm.canDeleteField
                              },
                              on: {
                                edit: function($event) {
                                  return _vm.editField(props.item)
                                },
                                delete: function($event) {
                                  return _vm.askConfirmationToDeleteItem(
                                    props.item
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                }
              },
              {
                key: "pageText",
                fn: function(props) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(props.pageStart) +
                        " - " +
                        _vm._s(props.pageStop) +
                        " " +
                        _vm._s(_vm.$t("tables.Of")) +
                        "\n        " +
                        _vm._s(props.itemsLength) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "no-results",
                fn: function() {
                  return [
                    _c("data-table-no-results", {
                      attrs: { search: _vm.searchFromParent }
                    })
                  ]
                },
                proxy: true
              },
              {
                key: "no-data",
                fn: function() {
                  return [
                    _vm.loading
                      ? _c("div")
                      : _c(
                          "v-alert",
                          {
                            staticClass: "data-table-no-data",
                            attrs: { icon: "warning" }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("NoCustomFields")) +
                                "\n        "
                            )
                          ]
                        )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.deleteDialog,
          title: _vm.$t("DeleteCustomField"),
          content:
            _vm.$t("DeleteConfirmation") + " " + _vm.itemToDelete.label + "?",
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes"),
          loading: _vm.loadingDelete
        },
        on: { mainAction: _vm.cancelDelete, secondaryAction: _vm.deleteField }
      }),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.confirmDeleteDialog,
          title: _vm.$t("DeleteCustomField"),
          content: _vm.$t("CustomFieldInUse"),
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes"),
          loading: _vm.loadingDelete
        },
        on: {
          mainAction: function($event) {
            _vm.confirmDeleteDialog = false
          },
          secondaryAction: _vm.finalDelete
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-226ec46f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-226ec46f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/SystemSettings/CustomFields/CustomFieldsTable.vue
// module id = null
// module chunks = 